import { CASH_CROP_HARVEST_TYPES, RDCashCropSpecies } from '@cibo/core'
import {
  SCOPED_HARVEST_TYPE_OPTIONS,
  SCOPED_PRIORITY_HARVEST_TYPES,
} from '@cibo/landmanager/src/features/DetailEditing/CashCrop/types'
import { FieldLabel, useCiboAutoForm } from '@cibo/ui'
import { Autocomplete, AutocompleteRenderInputParams, FormControl, TextField } from '@mui/material'
import { connectField, filterDOMProps, useFormContext } from 'dynamic-uniforms'
import { useTranslation } from 'react-i18next'

export const HarvestTypeInput = (props: any) => {
  const { t } = useTranslation('@cibo/landmanager/CashCropEditor')

  const { name, label, required, disabled } = props

  const { model, onChange } = useFormContext()
  const { touch } = useCiboAutoForm()

  const crop = (model as any).value?.crop as RDCashCropSpecies | undefined

  return (
    <FormControl fullWidth {...filterDOMProps(props)} required={required} disabled={disabled}>
      {label && <FieldLabel label={label} required={required} />}

      <Autocomplete
        renderInput={(params: AutocompleteRenderInputParams) => (
          <TextField name={name} {...params} />
        )}
        options={
          (crop && SCOPED_HARVEST_TYPE_OPTIONS[crop as RDCashCropSpecies]) ||
          CASH_CROP_HARVEST_TYPES
        }
        groupBy={
          crop
            ? c =>
                SCOPED_PRIORITY_HARVEST_TYPES[crop as RDCashCropSpecies]?.includes(c)
                  ? t('suggested')
                  : t('all')
            : undefined
        }
        getOptionLabel={(option: string) => t(option)}
        // data-testid={`cashCrop.${year}.harvestType`}
        selectOnFocus
        value={props.value || ''}
        onChange={(_, value) => {
          onChange('value.harvestType', value === null ? undefined : value)
        }}
        onAbort={() => touch(name)}
      />
    </FormControl>
  )
}

export const HarvestTypeField = connectField(HarvestTypeInput)
